export default {
  from: 'dès',
  select: 'Selectionner',
  deal: 'offre',
  deals: 'offres',
  total: '',
  total_fr: 'Prix total : ',
  pp: 'pp',
}
